export default __webpack_public_path__ + "static/media/Asset190.03ec0a06.svg";